import React, {useState} from 'react';


function App({config, id, title}) {  

    return (
        <div className="title animate" data-animate="blendin 3s" id={id}>
       
                <div className="title-content">
                   
                    <img className="logo" src="./images/mco_logo.png" />
                    
                    <div className="main-subtitle">Wir heißen Sie willkommen.</div>
                    <div className=" main-title text-variable text-break">
                        <div className="">{config.name}</div> 
                    </div>
                    <div className="main-subtitle">Zusammen singen, zusammen bleiben.</div>
                    
                </div>
            
        </div>
      
        );
}

export default App;